import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  title: 'Planilla Inteligente de Control Financiero',
  desc: 'Registrá ingresos, gastos y ganancias de forma simple.'
}, {
  title: 'Desafío Ahorro 30 Días',
  desc: 'Creá hábitos financieros sólidos y sostenibles.'
}, {
  title: '50 Formas Reales de Generar Ingresos Extra',
  desc: 'Ideas prácticas para aumentar tus ingresos.'
}, {
  title: 'Guía Anti Deudas',
  desc: 'Métodos simples para salir de deudas más rápido.'
}, {
  title: 'Checklist Semanal Financiero',
  desc: 'Controlá tus números en pocos minutos por semana.'
}, {
  title: 'Manual para Dejar de Vivir Preocupado por el Dinero',
  desc: 'Reducí el estrés financiero y tomá decisiones con mayor seguridad.'
}];
export function BonusesSection() {
  return <section className="py-14 md:py-20 bg-surface relative overflow-hidden" data-id="element-16">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-surface-light to-transparent" data-id="element-17" />

      <div className="container mx-auto px-5 md:px-6" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-19">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-primary/10 mb-4 md:mb-5" data-id="element-20">
            <GiftIcon className="w-6 h-6 md:w-8 md:h-8 text-primary" data-id="element-21" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-5" data-id="element-22">
            ADEMÁS RECIBÍS{' '}
            <span className="text-primary italic" data-id="element-23">6 BONUS DE REGALO</span>
          </h2>
          <p className="text-sm md:text-xl text-text-muted" data-id="element-24">
            Herramientas prácticas para acelerar tus resultados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 max-w-6xl mx-auto" data-id="element-25">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(i * 0.07, 0.35)
        }} whileHover={{
          y: -3
        }} className="bg-background rounded-2xl p-4 md:p-6 border border-surface-light hover:border-primary/40 transition-colors group relative overflow-hidden" data-id="element-26">
              <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-bl-full -mr-12 -mt-12 transition-transform group-hover:scale-110" data-id="element-27" />

              <div className="flex justify-between items-center mb-3 md:mb-4 relative z-10" data-id="element-28">
                <span className="text-[10px] md:text-xs font-bold tracking-widest text-primary uppercase" data-id="element-29">
                  Bonus {i + 1}
                </span>
                <div className="w-7 h-7 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center" data-id="element-30">
                  <GiftIcon className="w-3.5 h-3.5 text-primary" data-id="element-31" />
                </div>
              </div>

              <h3 className="text-base md:text-lg font-serif text-white mb-1.5 md:mb-2 relative z-10 leading-tight" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-xs md:text-sm text-text-muted relative z-10 leading-snug" data-id="element-33">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}